import { render, staticRenderFns } from "./CritereVariete.vue?vue&type=template&id=372bc930"
import script from "./CritereVariete.vue?vue&type=script&lang=js"
export * from "./CritereVariete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports